import API, { adminHeader } from '../config/axios'

const operatorsAPI = {
	getOrganizationData: () => {
		return API.get('/Operators/me')
			.then(res => res)
	},


	getOrganizationDataID: id => {
		return API.get(`/Operators/${id}`)
			.then(res => res)
			.catch(err => err)
	},
	resetAPIToken: () => {
		return API.put('/Operators/createAPIToken')
			.then(res => res)
			.catch(err => err)
	},
	getOperators: () => {
		return API.get('/Operators', { headers: adminHeader })
			.then(res => res)
			.catch(err => err)
	},
	getOperatorsAll: () => {
		return API.get('/Operators/all', { headers: adminHeader })
			.then(res => res)
			.catch(err => err)
	},
	editOperatorContactInfo: (mobile, email, smsTelephone) => {
		return API.put('/Operators/me', { mobile, email, smsTelephone })
			.then(res => res)
			.catch(err => err)
	},
	updateOperatorContactInfo: (id, mobile, email, smsTelephone, isUseReport1_1_2, operatorQOS, startDate, endDate) => {
		return API.put(`/Operators/${id}/contact-info`, { mobile, email, smsTelephone, isUseReport1_1_2, operatorQOS, startDate, endDate })
			.then(res => res)
			.catch(err => err)
	},
	createOperator: (payload) => {
		return API.post('/Operators/add', payload)
			.then(res => res)
			.catch(err => err)
	},
	getQOSTypes: () => {
		return API.get('/QOSTypes')
			.then(res => res)
			.catch(err => err)
	},
	searchDBD: (payload) => {
		return API.post('/Operators/searchDBD_V2', payload)
			.then(res => res)
			.catch(err => err)
	},
	getOperatorInfoDBD: (payload) => {
		const { taxno, pid } = payload;
		return API.post('/Operators/searchDBD_V2', { taxno: taxno, pid: pid })
			.then(res => res)
	},
	getOperatorInfo: async (payload) => {
		const { taxno, branchno } = payload;
		const form = new FormData()
		form.append('taxNo', taxno)
		form.append('branchNo', branchno)
		return API({
			url: `/Operators/OperatorInfo`,
			method: 'POST',
			data: form,
		})
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err
			})
	},
	getOperatorUserInfo: async (payload) => {
		const { cardNo } = payload;
		const form = new FormData()
		form.append('cardNo', cardNo)
		return API({
			url: `/Operators/OperatorUserInfo`,
			method: 'POST',
			data: form,
		})
			.then(res => res)
			.catch(err => {
				console.error(err)
				return err
			})
	}
}
export default operatorsAPI
